import { Route, Routes } from "react-router-dom";
import './style.css';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from "./pages/Home/Home";
import ProductionService from "./pages/ProductionService/ProductionService";
import Locations from "./pages/Locations/Locations";
import Productions from "./pages/Productions/Productions";
import OwnDeveloped from "./pages/OwnDeveloped/OwnDeveloped";
import DetailProd from "./pages/DetailProd/DetailProd";
import Team from "./pages/Team/Team";
import DetailTeam from "./pages/DetailTeam/DetailTeam";
import Podcast from "./pages/Podcast/Podcast";
import Contact from "./pages/Contact/Contact";
import { createContext, useState, useEffect, useMemo } from "react";
import DetailDeveloped from "./pages/DetailDeveloped/DetailDeveloped";
import { useLocation, useNavigate } from "react-router-dom";
import { getPrefix } from "./helpers/prefixHelper";
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import StagesBacklots from "./pages/StagesBacklots/StagesBacklots";

library.add(fas, far, fab)

export const language = createContext({})

function App() {
  // Declare location and navigate first
  const navigate = useNavigate();
  const location = useLocation(); // Declare location here

  // englishPaths variable is no longer needed as logic directly checks for '/en' prefix

  // Initial language determination based on current path
  // Now location is defined when used here
  const isEnglishPathInitial = location.pathname.startsWith('/en');
  const [currentLanguage, setCurrentLanguage] = useState(isEnglishPathInitial ? "en" : "hu");

  // prefix is likely not needed here if navigation handles the full path
  // const prefix = getPrefix(currentLanguage);


  // Effect to handle language change based on URL path changes
  // This effect is the single source of truth for language based on URL
  useEffect(() => {
    const pathIncludesEnglishPrefix = location.pathname.startsWith('/en');

    if (pathIncludesEnglishPrefix) {
      setCurrentLanguage('en');
    } else {
      setCurrentLanguage('hu');
    }

  }, [location.pathname]); // Re-run effect when pathname changes

  const changeLanguage = (lang) => {
    if (typeof lang === "string" && lang) {
      // If a specific language is passed, set it directly
      setCurrentLanguage(lang);
      // You might want to update the URL here based on the target language
      // For simplicity, the logic below handles toggling
    } else if (currentLanguage === 'hu') {
      // Switch from Hungarian to English
      setCurrentLanguage('en');
      let stateObj = { id: "100" };
      // Add '/en' prefix if not already present and navigate
      let newPath = window.location.pathname.startsWith('/en') ? window.location.pathname : `/en${window.location.pathname}`;
      window.history.pushState(stateObj, "/en", newPath);
      navigate(newPath); // Navigate directly to the new path
    } else { // currentLanguage is 'en'
      // Switch from English to Hungarian
      setCurrentLanguage('hu');
      let stateObj = { id: "100" };
      // Remove '/en' prefix if present and navigate
      let newPath = window.location.pathname.startsWith('/en') ? window.location.pathname.substring(3) : window.location.pathname;
       // Ensure the path is not empty, default to '/' if it is
      if (newPath === '') newPath = '/';
      window.history.pushState(stateObj, "/hu", newPath);
      navigate(newPath); // Navigate directly to the new path
    }
  };

  // useEffect(() => {
  //   changeLanguage(window.localStorage.getItem('CURRENT_LANGUAGE'))
  // }, [])

  // useEffect(() => {
  //   window.localStorage.setItem('CURRENT_LANGUAGE', currentLanguage);
  // }, [currentLanguage])

  useEffect(() => {
    if (location.pathname !== '/') {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <div>
      {/* Pass changeLanguage and currentLanguage via context */}
      <language.Provider value={{ currentLanguage, changeLanguage, getPrefix }}>
        <Header />
        <Routes >
            {/* English Routes */}
            <Route exact path={`/en/`} element={<Home/>}/>
            <Route path={`/en/service-production`} element={<ProductionService/>}/>
            <Route path={`/en/service-production/locations`} element={<Locations/>}/>
            <Route path={`/en/service-production/stages-and-backlots`} element={<StagesBacklots/>}/>
            <Route path={`/en/produkciok`} element={<Productions/>}/>
            <Route path={`/en/produkciok/:id`} element={<DetailProd/>}/>
            <Route path={`/en/sajat-fejlesztesek`} element={<OwnDeveloped/>}/>
            <Route path={`/en/sajat-fejlesztesek/:id`} element={<DetailDeveloped/>}/>
            <Route path={`/en/csapat`} element={<Team/>}/>
            <Route path={`/en/csapat/:id`} element={<DetailTeam/>}/>
            <Route path={`/en/podcast`} element={<Podcast/>}/>
            <Route path={`/en/kapcsolat`} element={<Contact/>}/>
            {/* Hungarian Routes (no /en prefix) */}
            <Route exact path={`/`} element={<Home/>}/>
            <Route path={`/produkciok`} element={<Productions/>}/>
            <Route path={`/produkciok/:id`} element={<DetailProd/>}/>
            <Route path={`/sajat-fejlesztesek`} element={<OwnDeveloped/>}/>
            <Route path={`/sajat-fejlesztesek/:id`} element={<DetailDeveloped/>}/>
            <Route path={`/csapat`} element={<Team/>}/>
            <Route path={`/csapat/:id`} element={<DetailTeam/>}/>
            <Route path={`/podcast`} element={<Podcast/>}/>
            <Route path={`/kapcsolat`} element={<Contact/>}/>
        </Routes>
        <Footer />
      </language.Provider>
    </div>
  );
}

export default App;
